export default {
  cataloger: {
    materials: {
      title: 'Solicitudes',
    },
    catalog: {
      title: 'Catalogo',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/routes/cataloger.js